/**
 * Bourbon City Spectacular meet page toggle.
 *
 * Live at /bourbon-city-spectacular when true (nav, footer, routes, sitemap).
 * Keep scripts/generate-sitemap.js MEET_PAGE_ENABLED in sync.
 */
export const MEET_PAGE_ENABLED = true;

/**
 * Owner enrollment dashboard at /owner/dashboard
 * Requires DASHBOARD_PASSWORD on Netlify + optional GA4 service account.
 * See docs/ENROLLMENT_DASHBOARD_SETUP.md
 */
export const ENROLLMENT_DASHBOARD_ENABLED = true;

export const isMeetPagePath = (path) =>
  path === "/bourbon-city-spectacular" || path.startsWith("/meet-info/");
